import Axios from 'axios';
import { Url } from '../general/modules/url';
import { GetLinkedAccountsInfoResponse } from '../accounts/tethers-types';
import { GetConsentResponseType } from '../marketing/get-consent-response-type';

export async function requestAccountWindow(
    suid: string,
    linkedAccountsInfo: GetLinkedAccountsInfoResponse,
    consentState: GetConsentResponseType
): Promise<string> {
    const response = await Axios.post<string>(Url.getNoLangUrl('api/renderAccountView'), {
        suid,
        linkedAccountsInfo,
        consentState
    });

    return response.data;
}
